import React, { useState, useReducer, useContext, useEffect } from 'react';
import { 
  MeansOfDisbursementContainer,
  MeansOfDisbursementWrapper,
  MeansOfDisbursementHeader,
  MeansOfDisbursementHeaderTitle,
  MeansOfDisbursementHeaderArea,
  MeansOfDisbursementContent,
} from './styles';
import colors from '../../assets/styles/colors';
import { H4, P } from '../../components/Typography/styles';
import { meansOfDisbursementSteps } from '../../helpers/enum';
import INITIAL_STATE_MEANS_OF_DISBURSEMENT from '../../store/MeansOfDisbursement/state';
import meansOfDisbursementReducer from '../../store/MeansOfDisbursement';
import { MeansOfDisbursementContext } from '../../store';
import DisbursementModalityPage from './DisbursementModality';
import SuggestedCustomerSegmentAndTypePage from './SuggestedCustomerSegmentAndType';
import FormSteps from '../../components/FormSteps';
import Copyright from '../../components/Copyright';
import Loader from '../../components/Loader';
import { useHistory, useLocation } from 'react-router-dom';
import { getCreditById } from '../../services/credit';
import { default as MeansOfDisbursementTypes } from '../../store/MeansOfDisbursement/types';
import { getSolicitationById } from '../../services/solicitations';

const MeansOfDisbursementPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [meansOfDisbursement, setMeansOfDisbursement] = useReducer(meansOfDisbursementReducer, INITIAL_STATE_MEANS_OF_DISBURSEMENT);
  const [activeStep, setActiveStep] = useState(meansOfDisbursementSteps.DISBURSEMENT_MODALITY);
  const [lastStep, setLastStep] = useState(meansOfDisbursementSteps.DEFAULT);
  const [isLoading, setIsLoading] = useState(true);

  async function initializeStateComponent() {
    try {
      if(!location.idCredit) {
        return history.push('/admin/dashboard');
      }

      const creditResponse = await getCreditById(location.idCredit);
      const solicitationResponse = await getSolicitationById(location.idCredit);

      setMeansOfDisbursement({
        type: MeansOfDisbursementTypes.SET_CREDIT,
        credit: creditResponse.data
      })
      setMeansOfDisbursement({
        type: MeansOfDisbursementTypes.SET_SOLICITATION,
        solicitation: solicitationResponse.data
      })

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  useEffect(() => {
    initializeStateComponent();
  }, [])

  return (
    <MeansOfDisbursementContainer id="means-of-disbursement-page">
      <MeansOfDisbursementWrapper>
        <MeansOfDisbursementHeader>
          <MeansOfDisbursementHeaderTitle>Clientes</MeansOfDisbursementHeaderTitle>
          <MeansOfDisbursementHeaderArea>
            <H4 color={colors.textPrimary}>Medio de desembolso</H4>
            <P bold color={colors.textPrimary}>
            {meansOfDisbursement.solicitation?.cliente.nombres} {meansOfDisbursement.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {meansOfDisbursement.solicitation?.cliente.identificacion}
            </P>
          </MeansOfDisbursementHeaderArea>
        </MeansOfDisbursementHeader>
        <MeansOfDisbursementContent id="means-of-disbursement-steps">
          <FormSteps lastStep={lastStep} steps={[
            {number: meansOfDisbursementSteps.DISBURSEMENT_MODALITY, label: 'Modalidad desembolso'}
          ]} />

          <MeansOfDisbursementContext.Provider value={{ meansOfDisbursement, setMeansOfDisbursement }}>
            {activeStep === meansOfDisbursementSteps.DISBURSEMENT_MODALITY && (
              <DisbursementModalityPage setActiveStep={setActiveStep} setLastStep={setLastStep} idSimulation={location.idSimulation} />
            )}

            {activeStep === meansOfDisbursementSteps.SUGGESTED_CUSTOMER_SEGMENT_AND_TYPE && (
              <SuggestedCustomerSegmentAndTypePage setActiveStep={setActiveStep} setLastStep={setLastStep} />
            )}
          </MeansOfDisbursementContext.Provider>
        </MeansOfDisbursementContent>
        {isLoading && <Loader />}
      </MeansOfDisbursementWrapper>
      <Copyright />
    </MeansOfDisbursementContainer>
  )
}

export default MeansOfDisbursementPage
